import { render, staticRenderFns } from "./RequiredServiceView.vue?vue&type=template&id=44415875&scoped=true&"
import script from "./RequiredServiceView.vue?vue&type=script&lang=js&"
export * from "./RequiredServiceView.vue?vue&type=script&lang=js&"
import style0 from "./RequiredServiceView.vue?vue&type=style&index=0&id=44415875&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44415875",
  null
  
)

export default component.exports